export const focusVisibleRing = [
  'outline-hidden',
  'focus-visible:z-10',
  'focus-visible:ring-3',
  'focus-visible:ring-focus',
  'focus-visible:ring-offset-2',
  'focus-visible:ring-offset-background'
];

export const focusVisibleWithinRing = [
  'outline-hidden',
  'has-focus-visible:z-10',
  'has-focus-visible:ring-3',
  'has-[:focus-visible]:ring-focus',
  'has-focus-visible:ring-offset-2',
  'has-[:focus-visible]:ring-offset-background'
];
